module.exports = __webpack_public_path__ + "img/FUN-Menu-14.6bd711e2.png";